if (!window.customElements.get('content-grid-number')) {
  class ContentGridNumber extends HTMLElement {
    constructor() {
      super();
      this._raw = (this.getAttribute('data-number') || this.textContent || '').trim();
      this._parsed = this._parse(this._raw);
      this._animated = false;
      this._onIntersect = this._onIntersect.bind(this);
    }

    connectedCallback() {
      if (!this._parsed) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (window.animation === false || reduceMotion) {
        this.textContent = this._format(this._parsed.target);
        return;
      }

      this._lockWidth();
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          if (!this._animated) this._lockWidth();
        });
      }

      this.textContent = this._format(0);

      if (!('IntersectionObserver' in window)) {
        this._animate();
        return;
      }

      this._observer = new IntersectionObserver(this._onIntersect, { threshold: 0.4 });
      this._observer.observe(this);
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
      if (this._raf) cancelAnimationFrame(this._raf);
    }

    _lockWidth() {
      const current = this.textContent;
      this.style.minWidth = '';
      this.textContent = this._format(this._parsed.target);
      const width = this.getBoundingClientRect().width;
      this.textContent = current;
      if (width) this.style.minWidth = width + 'px';
    }

    _onIntersect(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) this._animate();
      });
    }

    _parse(raw) {
      const match = raw.match(/^(\D*?)([\d.,]+)(\D*)$/);
      if (!match) return null;

      const prefix = match[1];
      const numberPart = match[2];
      const suffix = match[3];

      const grouping = numberPart.indexOf(',') !== -1;
      const cleaned = numberPart.replace(/,/g, '');
      const target = parseFloat(cleaned);
      if (isNaN(target)) return null;

      const dotIndex = cleaned.indexOf('.');
      const decimals = dotIndex === -1 ? 0 : cleaned.length - dotIndex - 1;

      return { prefix, suffix, target, decimals, grouping };
    }

    _format(value) {
      const { prefix, suffix, decimals, grouping } = this._parsed;
      const fixed = value.toFixed(decimals);
      let [intPart, decPart] = fixed.split('.');

      if (grouping) {
        intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }

      const number = decPart ? intPart + '.' + decPart : intPart;
      return prefix + number + suffix;
    }

    _animate() {
      if (this._animated) return;
      this._animated = true;
      if (this._observer) this._observer.disconnect();

      const duration = 2000;
      const target = this._parsed.target;
      let startTime = null;

      const step = (timestamp) => {
        if (startTime === null) startTime = timestamp;
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 4);

        this.textContent = this._format(target * eased);

        if (progress < 1) {
          this._raf = requestAnimationFrame(step);
        } else {
          this.textContent = this._format(target);
          this.style.minWidth = '';
        }
      };

      this._raf = requestAnimationFrame(step);
    }
  }

  window.customElements.define('content-grid-number', ContentGridNumber);
}
//# sourceMappingURL=content-grid.js.map
